import { render, staticRenderFns } from "./CurrentSemesterWidget.vue?vue&type=template&id=7eb7cb0c"
import script from "./CurrentSemesterWidget.vue?vue&type=script&lang=js"
export * from "./CurrentSemesterWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports